const React = require('react');

const IntervalFilterConstructor = require('../IntervalFilterConstructor');

const SearchFilterMerchant = require('./components/SearchFilterMerchant');
const SelectFilterMerchant = require('./components/SelectFilterMerchant');
const IntervalFilterBlock = require("./components/IntervalFilterBlock");
const {BtnTableGlobalRefresh, BtnTableGlobalDownload} = require("../../../AdminHelpers/Buttons");
const noop = require("mn-utils/noop");
const map = require("mn-utils/map");
const SelectFilter = require("../IntervalFilterConstructor/components/SelectFilter");
const {INTERVALS, INTERVAL_CUSTOM} = require("../../constants/intervals");
const IntervalBtn = require("./components/IntervalBtn");
const TimeIntervalBtn = require("../IntervalFilterConstructor/components/TimeIntervalBtn");
const SearchFilter = require("../IntervalFilterConstructor/components/SearchFilter");
const getDateRange = require("../../utils/getDateRange");

const IntervalFilterMerchant = (props) => {
  const {
    // default data from high level
    data = {},
    onChange = noop,
    search = {},
    selectFilters = [],
    hideTimeInterval,
    hideSearch,
    disabled,

    className,
    update,
    report,
  } = props;

  return (
    <div className={'wAuto layoutRow fxwWrap mh-8 (mv8|ph8)>1 ' + (props.className || '')}>
      {map(selectFilters, (selectParams, id) => (
        <div key={id} className="fx1">
          <SelectFilter
            selectComponent={SelectFilterMerchant}
            selectParams={selectParams}
            data={data}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
      ))}
      {!hideTimeInterval && (
        <>
          <div className="fx1">
            <SelectFilterMerchant
              className="(bcA)>.MuiInputBase-root (pb12)>.MuiSelect-root (st50%|c717070)>.arrow-icon"
              propValue="id"
              propName="name"
              items={INTERVALS}
              value={data.interval}
              onChange={(interval) => {
                const dateRange = getDateRange({interval});
                onChange && onChange({...data, ...dateRange, interval})
              }}
            />
          </div>
          <div className="fx1">
            <TimeIntervalBtn
              item={{id: INTERVAL_CUSTOM}}
              data={data}
              btnComponent={IntervalBtn}
              onChange={onChange}
              disabled={disabled}
              isCustom
            />
          </div>
        </>
      )}
      {!hideSearch && (
        <div className="fx1">
          <SearchFilter
            data={data}
            search={search}
            searchComponent={SearchFilterMerchant}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
      )}
      {!!update && (
        <div>
          <BtnTableGlobalRefresh
            update={update}
          />
        </div>
      )}
      {!!report && (
        <div>
          <BtnTableGlobalDownload
            filter={data}
            report={report}
          />
        </div>
      )}
    </div>
  );
};

module.exports = IntervalFilterMerchant;
